<script>
	import { onDestroy, onMount } from "svelte";
	import { nav } from './store.js'
	let article;
	

	onMount(()=>{

		const wipeout = document.querySelector(".wipeout");
		wipeout.style.visibility = "hidden";
		wipeout.style.transform = "translateX(0%)";
		

		// Run the animation
		const container = article.children[0];
		let contrect;
		let containerMidX;
		let containerMidY;


		container.children[0].style.transform = "translateY(-100%) translateX(-10%)";
		container.children[1].style.transform = "translateY(-100%) translateX(10%)";
		container.children[2].style.transform = "translate(-50%, -80%) ";
		container.children[0].style.transition = "all 0.8s ease";
		container.children[1].style.transition = "all 0.8s ease";
		container.children[2].style.transition = "all 0.8s ease";

		setTimeout(() => {
			container.children[0].style.transform = "translateY(-100%)";
			container.children[0].style.opacity = "1";
		}, 333);
		setTimeout(() => {
			container.children[1].style.transform = "translateY(-100%)";
			container.children[1].style.opacity = "1";
		}, 666);
		setTimeout(() => {
			container.children[2].style.transform = "translate(-50%, -100%)";
			container.children[2].style.opacity = "1";
		}, 1000);
		setTimeout(() => {
			if (window.screen.width > 800) {
				contrect = container.getBoundingClientRect()
				containerMidX = contrect.left + (container.clientWidth/2) ;
				containerMidY = contrect.top + (container.clientHeight/2) ;
				a3devent();
			}
		}, 1800);
		function a3devent() {

			container.addEventListener('mouseenter', ()=>{
				article.style.width = "110vw";
				article.style.height = "110vh";
				article.style.marginLeft = "0px";
				
				
				container.children[0].style.transition = "all 0.3s ease";
				container.children[1].style.transition = "all 0.3s ease";
				container.children[2].style.transition = "all 0.3s ease";
				container.children[0].style.transform = "translateY(-100%) translateZ(40px)";
				container.children[1].style.transform = "translateY(-100%) translateZ(30px)";
				container.children[2].style.transform = "translate(-50%, -100%) translateZ(60px)";
				
				
				container.addEventListener("mousemove", e =>{
					var ofsetX = (e.clientX - containerMidX)/15 ;
					var ofsetY = (e.clientY - containerMidY)/20 ;
					
					container.children[0].style.transition = "background 0.3s ease";
					container.children[1].style.transition = "background 0.3s ease";
					container.children[2].style.transition = "background 0.3s ease";
					container.children[0].style.transform = "translateY(-100%) translateZ(40px)" + ` rotateX(${ofsetY}deg) rotateY(${ofsetX}deg)`; //rotate3d(${ofsetX}px, ${ofsetY}px, 0, 0)`
					container.children[1].style.transform = "translateY(-100%) translateZ(50px)"+ ` rotateX(${ofsetY}deg) rotateY(${ofsetX}deg)`;
					container.children[2].style.transform = "translate(-50%, -100%) translateZ(70px)"+ ` rotateX(${ofsetY}deg) rotateY(${ofsetX}deg)`;
				})
				
			})
			
		}
			container.addEventListener('mouseleave', ()=>{
				article.style.width = "";
				article.style.height = "";
				article.style.marginLeft = "";
				
				container.children[0].style.transform = "";
				container.children[1].style.transform = "";
				container.children[2].style.transform = "";
			})
			
	});

	function wipe (navfunc) {
		const wipeout = document.querySelector(".wipeout");
		wipeout.style.visibility = "visible";
		wipeout.style.transform = "translateX(-102%)";
		setTimeout(navfunc, 800);
	}

</script>

<section>

	<article bind:this={article}>
		<div>
			
			<h1>Some <br> Token</h1>
			<h2>A game of chance that doesn't need luck!</h2>
			<a on:click={(e)=>{ if (window.screen.width > 980) { e.preventDefault(); wipe(() => {  nav.set("vault") })}}} href="https://cointool.app/ido/exchange?id=236b722b27777726262021267750227127242424262b242a272b245077222a2b51277525572a202226726f2625"> 
				<svg width="31" height="24" viewBox="0 0 31 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M30.0607 13.0607C30.6464 12.4749 30.6464 11.5251 30.0607 10.9393L20.5147 1.3934C19.9289 0.807612 18.9792 0.807612 18.3934 1.3934C17.8076 1.97918 17.8076 2.92893 18.3934 3.51472L26.8787 12L18.3934 20.4853C17.8076 21.0711 17.8076 22.0208 18.3934 22.6066C18.9792 23.1924 19.9289 23.1924 20.5147 22.6066L30.0607 13.0607ZM0 13.5H29V10.5H0V13.5Z" fill="#FF7A22"/>
				</svg> 
				<h3>Buy Now</h3>
			</a>
		</div>
	</article>
	
	<img id="background" src="./Wawe.svg" alt="">
	<div class="lht-container">
		<svg id="LHT" width="366" height="222" viewBox="0 0 366 222" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path id="lht-t" d="M273.24 50.3849L248.4 65.671L258.214 111.809M273.24 50.3849L289.916 56.9789M273.24 50.3849L283.141 96.2432M293.042 142.102L268.029 157.947M293.042 142.102L308.328 146.618M293.042 142.102L283.141 96.2432M268.029 157.947L283.836 162.946L308.328 146.618M268.029 157.947L258.214 111.809M308.328 146.618L299.158 101.976M289.916 56.9789L326.394 71.4033L329.173 86.8631M289.916 56.9789L293.042 72.2006M293.042 72.2006L329.173 86.8631M293.042 72.2006L298.445 98.5014M329.173 86.8631L309.371 102.844L298.445 98.5014M298.445 98.5014L299.158 101.976M299.158 101.976L283.141 96.2432M283.141 96.2432L258.214 111.809" stroke="#FFF2E6" stroke-width="2"/>
			<path id="lht-h" d="M160.331 50.3849L134.97 65.671L144.09 111.809M160.331 50.3849L175.27 55.4224L181.359 85.2997M160.331 50.3849L169.277 95.1141M193.856 146.618L178.223 139.843M193.856 146.618L169.364 165.031L153.209 157.947M193.856 146.618L190.316 129.247M178.223 139.843L153.209 157.947M178.223 139.843L169.277 95.1141M153.209 157.947L144.09 111.809M144.09 111.809L169.277 95.1141M181.359 85.2997L184.758 101.976M181.359 85.2997L187.95 88.1771M184.758 101.976L222.694 116.914M184.758 101.976L190.316 129.247M210.88 60.6335L225.123 65.671L243.884 157.947M210.88 60.6335L184.758 76.4408L187.95 88.1771M210.88 60.6335L219.558 101.976M229.987 151.655L205.668 167.636M229.987 151.655L243.884 157.947M229.987 151.655L222.694 116.914M205.668 167.636L219.044 173.89L243.884 157.947M205.668 167.636L199.241 132.895M199.241 132.895L222.694 116.914M199.241 132.895L190.316 129.247M222.694 116.914L219.558 101.976M219.558 101.976L187.95 88.1771" stroke="#FFF2E6" stroke-width="2"/>
			<path id="lht-l" d="M62.5347 45L37 60.6335L47.4223 106.666M62.5347 45L77.4734 50.3849L87.0273 97.1117M62.5347 45L72.2623 91.2057M87.0273 97.1117L72.2623 91.2057M87.0273 97.1117L92.9333 125.426M72.2623 91.2057L47.4223 106.666M72.2623 91.2057L81.6424 135.848M47.4223 106.666L56.9762 151.655M81.6424 135.848L96.1852 142.102M81.6424 135.848L56.9762 151.655M133.754 158.256L131.322 142.102L92.9333 125.426M133.754 158.256L96.1852 142.102M133.754 158.256L110.999 173.89L72.2623 157.947M92.9333 125.426L96.1852 142.102M96.1852 142.102L72.2623 157.947M56.9762 151.655L72.2623 157.947" stroke="#FFF2E6" stroke-width="2"/>
		</svg>
	</div>
	<div on:click={()=>{wipe(() => (nav.set("about")))}} class="navbutton">
		<svg width="31" height="24" viewBox="0 0 31 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M30.0607 13.0607C30.6464 12.4749 30.6464 11.5251 30.0607 10.9393L20.5147 1.3934C19.9289 0.807612 18.9792 0.807612 18.3934 1.3934C17.8076 1.97918 17.8076 2.92893 18.3934 3.51472L26.8787 12L18.3934 20.4853C17.8076 21.0711 17.8076 22.0208 18.3934 22.6066C18.9792 23.1924 19.9289 23.1924 20.5147 22.6066L30.0607 13.0607ZM0 13.5H29V10.5H0V13.5Z" fill="#FF7A22"/>
		</svg> 
	</div>
	
</section>

<style>
	@keyframes lht-move{
	
		0%{
			transform: translateY(-15px)
		}
		50%{
			transform: translateY(18px)
		}
		100%{
			transform: translateY(-15px)
		}
	}
	section{
		width: 100vw;
		height: 100vh;
		display: flex;
		align-items: center;
		justify-content: flex-start;

		overflow: hidden;
	}
	article{
		border-radius: 10px;
		background-color: rgba(0, 0, 0, 0.25);
		width: 80vw;
		height: 70vh;
		margin-left: 10%;
		text-align: center;

		transition: all 0.3s ease;
	}
	article div{
		position: absolute;
		left: 50%;
		transform: translateX(-50%);
		top: 15%;
		width: 60vw;
		height: 70vh;

		transform-style: preserve-3d;
		perspective: 1000px;
	}
	article div h1{
		width: 100%;
		margin: 0;
		padding: 0 1rem;
		position: absolute;
		left: 0;
		top: 40%;
		transform: translateY(-100%) ;
		opacity: 0;
		font-size: 3.6rem;
		text-transform: uppercase;
		transition: all 0.3s ease;
	}
	article div h2{
		padding: 0 1rem;
		width: 100%;
		margin: 0;
		position: absolute;
		left: 0;
		top: 70%;
		transform: translateY(-100%);
		opacity: 0;
		font-size: 2.7rem;
		text-transform: uppercase;
		transition: all 0.3s ease;
	}
	article div a{
		min-width: 14rem;
		position: absolute;
		left: 50%;
		top: 95%;
		transform: translate(-50%, -100%) ;
		opacity: 0;

		text-decoration: none;
		color: white;

		display: flex;
		align-items: center;
		justify-content: center;
		padding: 1rem 2rem;
		border-radius: 50vh;
		border: 2px solid white;
		transition: all 0.3s ease;
	}
	article div a:hover{
		text-decoration: none;
		color: #FF7A22;
		background: white;
	}
	article div a svg{
		height: 1rem;
		width: auto;
	}
	article div a h3{
		font-size: 1.8rem;
		margin: 0;
		margin-left: 1rem;
	}


	img#background{
		position: absolute;
		bottom: -30%;
		left: 0;
		z-index: -10;
		
		width: 100vw;
		transform: scaleY(70%);
	}
	.lht-container{
		position: absolute;
		bottom: 0rem;
		right: 1rem;
		z-index: 70;
		padding: 1rem;
		border-radius: 10px;
	}
	svg#LHT{
		z-index: -5;
		height: 6rem;
		width: auto;
	}

	svg#LHT #lht-t{
		animation-name: lht-move;
		animation-duration: 4.5s;
		animation-iteration-count: infinite;
	}
	svg#LHT #lht-l{
		animation-name: lht-move;
		animation-duration: 4s;
		animation-iteration-count: infinite;
	}
	svg#LHT #lht-h{
		animation-name: lht-move;
		animation-duration: 4.2s;
		animation-iteration-count: infinite;
	}

	.navbutton{
		position: absolute;
		width: 3rem;
		height: 3rem;
		top: 50%;
		left: 100%;
		transform: translate(-80%, -50%);

		display: flex;
		align-items: center;
		justify-content: flex-start;
		padding-left: 0.5rem;
		background-color: rgba(0, 0, 0, 0.5);
		border-radius: 50vh;
		transition: all 0.3s ease;
		cursor: pointer;
	}
	.navbutton svg{
		width: 1.5rem;
		height: 2rem;
	}
	.navbutton:hover{
		transform: translate(-90%, -50%) scale(140%);
		background-color: rgba(0, 0, 0, 0.75);
	}



	@media only screen and (max-width: 1000px){

		
		article div h1{
			width: 100%;
			margin: 0;
			
			position: absolute;
			left: 0;
			/* changed */
			top: 40%;
			/* changed */
			user-select: none;
			
			transform: translateY(-100%) ;
			opacity: 0;

			/* changed */
			font-size: 2.7rem;
			text-transform: uppercase;
			transition: all 0.3s ease;
		}
		article div h2{
			padding: 0 1rem;
			width: 100%;
			margin: 0;
			position: absolute;
			left: 0;
			/* changed */
			top: 65%;
			/* changed */
			user-select: none;
	
			transform: translateY(-100%);
			opacity: 0;
			/* changed */
			font-size: 1.8rem;
			text-transform: uppercase;
			transition: all 0.3s ease;
		}
		article div a{
			/* changed */
			min-width: 14rem;
			position: absolute;
			left: 50%;
			/* changed */
			top: 90%;
			
	
			transform: translate(-50%, -100%) ;
			opacity: 0;

			text-decoration: none;
			color: white;

			display: flex;
			align-items: center;
			justify-content: center;
			/* changed */
			padding: 1.2rem 1.8rem;
			border-radius: 50vh;
			border: 2px solid white;
			transition: all 0.3s ease;
		}
		article div a:hover{
			text-decoration: none;
			color: #FF7A22;
			background: white;
		}
		article div a svg{
			/* changed */
			height: 1rem;
			width: auto;
		}
		article div a h3{
			/* changed */
			font-size: 1.2rem;
			margin: 0;
			margin-left: 1rem;
			/* changed */
			user-select: none;
		}


		
	}

	@media only screen and (max-width: 700px){
		section{
			width: 100vw;
			height: 100vh;
			display: flex;
			align-items: center;
			justify-content: flex-start;

			overflow: hidden;
		}
		article{
			border-radius: 10px;
			background-color: rgba(0, 0, 0, 0.25);
			width: 80vw;
			/* changed */
			height: 65vh;
			margin-left: 10%;
			text-align: center;

			transition: all 0.3s ease;
		}
		article div{
			position: absolute;
			left: 50%;
			transform: translateX(-50%);
			/* changed */
			top: 15%;
			width: 60vw;
			/* changed */
			height: 65vh;
	


			transform-style: preserve-3d;
			perspective: 1000px;
		}
		article div h1{
			width: 100%;
			margin: 0;
			/* changed */
			padding: 0;
			position: absolute;
			left: 0;
			/* changed */
			user-select: none;
			/* changed */
			top: 30%;
			transform: translateY(-100%) ;
			opacity: 0;

			/* changed */
			font-size: 2rem;
			text-transform: uppercase;
			transition: all 0.3s ease;
		}
		article div h2{
			padding: 0 1rem;
			width: 100%;
			margin: 0;
			position: absolute;
			left: 0;
			/* changed */
			user-select: none;
			/* changed */
			top: 65%;
			transform: translateY(-100%);
			opacity: 0;
			/* changed */
			font-size: 1.5rem;
			text-transform: uppercase;
			transition: all 0.3s ease;
		}
		article div a{
			/* changed */
			min-width: 12rem;
			position: absolute;
			left: 50%;
			
			/* changed */
			top: 90%;
			transform: translate(-50%, -100%) ;
			opacity: 0;

			text-decoration: none;
			color: white;

			display: flex;
			align-items: center;
			justify-content: center;
			/* changed */
			padding: 1rem 1.5rem;
			border-radius: 50vh;
			border: 2px solid white;
			transition: all 0.3s ease;
		}
		article div a:hover{
			text-decoration: none;
			color: #FF7A22;
			background: white;
		}
		article div a svg{
			/* changed */
			height: 0.8rem;
			width: auto;
		}
		article div a h3{
			/* changed */
			font-size: 1rem;
			margin: 0;
			margin-left: 1rem;
			/* changed */
			user-select: none;
		}


		img#background{
			position: absolute;

			/* changed  */
			top: 100%;
			
			
			/*
			bottom: -30%;
			*/
			left: 0;
			z-index: -10;
			
			/* changed */ 
			width: 100vw;
			/* changed  */
			transform: scaleY(150%) translateY(-100%) ;
		}
		.lht-container{
			position: absolute;
			/* changed */
			top: calc(100vh - 7.4rem);
			/* changed */
			right: 0rem;

			/* changed */
			padding: 0.5rem;
			border-radius: 10px;
		}
		svg#LHT{
			z-index: -5;
			/* changed */
			height: 3rem;
			width: auto;
		}
	}

</style>